<cdx-slotted-modal (close)="close()" [mobileFullHeight]="true">
    <h1 modal-header>Choose a delivery address</h1>
    <fulfilment-delivery-address-selection [addAddressRoute]="modalRoutes.ADD_DELIVERY_ADDRESS_PATH"
                                           modal-content
                                           (addressSelected)="close()"
                                           [modal]="modalRoutes.HWW_MODAL"></fulfilment-delivery-address-selection>
</cdx-slotted-modal>